import { Async } from '@client/new/helpers/types';
import React from 'react';

export type MutationStatus<T extends { id: string } = { id: string }> = {
  name: string; //ceratePDF | updateTab| reorder ... // ro
  payload: T; // ro
  id: string; // ro

  value: Async<any>; // result | error | pending
  ts: number;
};

export const useMutationLog = () => {
  const [state, setState] = React.useState<Array<MutationStatus<any>>>([]);
  const add = <T extends { id: string }>(
    e: Pick<MutationStatus<T>, 'name' | 'payload'>,
  ) => {
    const { id } = e.payload;
    if (!id) return;
    setState((prev) => {
      // Remove any existing mutations for this id to avoid stale state
      const filtered = prev.filter((m) => m.id !== id);
      return [
        ...filtered,
        { ...e, ts: Date.now(), value: { type: 'fetching' }, id },
      ];
    });
  };

  const update = (id: string, value: Async<any>) => {
    setState((prev) => {
      return prev.map((m) => {
        if (m.id === id) return { ...m, value, ts: Date.now() };
        return m;
      });
    });
  };

  const get = (id: string) => state.find((m) => m.id === id) || null;

  const isMutationRunning = state.some((m) => m.value.type === 'fetching');

  /**
   * Check if a specific content item is currently being mutated.
   * Useful for showing loading indicators on specific items in ViewModel.
   *
   * @param contentId - The ID of the content item to check
   * @returns true if the item is being created, updated, or deleted
   */
  const isItemMutating = (contentId: string): boolean => {
    const mutation = get(contentId);
    return mutation?.value.type === 'fetching';
  };

  return { add, update, get, isMutationRunning, isItemMutating };
};
